import React from "react";
import { useSelector } from "react-redux";

const AskValue = React.memo(({ symbolId, digits }) => {
  const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])

  return <span className={`${symbol?.askColor == 'down' && 'red'} ${symbol?.askColor == 'up' && 'green'} `}>{symbol ? symbol?.ask?.toFixed(digits || symbol.digits) : '0.00'}</span>;
});

export default AskValue;